import React,{useContext} from 'react'
import {Link} from 'react-router-dom'
import { UserContext } from '../App'


function Navbar() {
  const {state,dispatch} = useContext(UserContext);
  const RenderNav = ()=>{
    if(state){
      return(
        <>
          <li class="nav-item active">
        <Link class="nav-link" to="/">Home</Link>
      </li>
      <li class="nav-item active">
        <Link class="nav-link" to="/about">About</Link>
      </li>
      <li class="nav-item active">
        <Link class="nav-link" to="/contact">Contact</Link>
      </li>
      <li class="nav-item active">
        <Link class="nav-link" to="/logout">Log Out</Link>
      </li>
        </>
      )
    }else{
      return(
        <>
          <li class="nav-item active">
        <Link class="nav-link" to="/">Home</Link>
      </li>
      <li class="nav-item active">
        <Link class="nav-link" to="/about">About</Link>
      </li>
      <li class="nav-item active">
        <Link class="nav-link" to="/contact">Contact</Link>
      </li>
      <li class="nav-item active">
        <Link class="nav-link" to="/signin">Sign In</Link>
      </li>
      <li class="nav-item active">
        <Link class="nav-link" to="/register">Register</Link>
      </li>
        </>
      )
    }
  }
  return (
    <div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <a class="navbar-brand" href="/">UAM<span className='text-primary'> REGS</span></a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav ml-auto">
      <RenderNav/>
    </ul>
  </div>
</nav>
    </div>
  )
}

export default Navbar